import {AfterViewInit, Component, OnDestroy, QueryList, ViewChildren,} from "@angular/core";
import {HeatingModel,} from "../../../../../../models/collected-data-model";
import {NgModel} from "@angular/forms";
import {OptionModel} from "../../../../../../models/option-model";
import {AutoSaveService} from '../../../../../../services/auto-save.service';
import {Subscription} from 'rxjs';
import {ShareService} from "../../../../../../services/share.service";
import {ValidationService} from "../../../../../../services/validation.service";
import {debounceTime} from "rxjs/operators";
import {HeatingInformationModel} from '../../../../../../models/data-models/heating-information-model';
import {GeneralGatewayModel} from '../../../../../../models/data-models/general-gateway-model';

@Component({
  selector: "app-install-heating-information",
  templateUrl: "./install-heating-information.component.html",
  styleUrls: ["./install-heating-information.component.scss"],

})
export class InstallHeatingInformationComponent implements AfterViewInit, OnDestroy {
  public model: HeatingInformationModel = new HeatingInformationModel();
  public generalGatewayModel: GeneralGatewayModel = new GeneralGatewayModel();

  public readonly LOW_IMAGE_QUALITY = AutoSaveService.LOW_IMAGE_QUALITY;

  public readonly HeatingTypeEnum = {
    DISTRICT: "DISTRICT",
    GAS: "GAS",
    OIL: "OIL",
    WOOD: "WOOD",
    PELLET: "PELLET",
    ELECTRIC: "ELECTRIC",
    HEAT_PUMP: "HEAT_PUMP",
    BHKW: "BHKW",
    SOLAR_THERMAL: "SOLAR_THERMAL",
    INFRARED: "INFRARED",
    SUB_DISTRIBUTION: "SUB_DISTRIBUTION",
  };
  public readonly ControlEnum = {
    BOILERS: "BOILERS",
    EXTERNAL: "EXTERNAL",
  };

  public heatingTypeOptions: OptionModel[] = [
    {label: "BHKW", value: this.HeatingTypeEnum.BHKW},
    {label: "Elektroheizung", value: this.HeatingTypeEnum.ELECTRIC},
    {label: "Fernwärme", value: this.HeatingTypeEnum.DISTRICT},
    {label: "Gasheizung", value: this.HeatingTypeEnum.GAS},
    {label: "Holzheizung", value: this.HeatingTypeEnum.WOOD},
    {label: "Infrarotheizung", value: this.HeatingTypeEnum.INFRARED},
    {label: "Pelletheizung", value: this.HeatingTypeEnum.PELLET},
    {label: "Solarthermie", value: this.HeatingTypeEnum.SOLAR_THERMAL},
    {label: "Unterverteilung", value: this.HeatingTypeEnum.SUB_DISTRIBUTION},
    {label: "Wärmepumpen", value: this.HeatingTypeEnum.HEAT_PUMP},
    {label: "Ölheizung", value: this.HeatingTypeEnum.OIL},
  ];

  public manufacturerTypeOptions: OptionModel[] = [
    {label: "Buderus", value: "Buderus"},
    {label: "Brötje", value: "Brötje"},
    {label: "Hoval", value: "Hoval"},
    {label: "Junkers", value: "Junkers"},
    {label: "Vaillant", value: "Vaillant"},
    {label: "Viessmann", value: "Viessmann"},
    {label: "Weishaupt", value: "Weishaupt"},
    {label: "Wolf", value: "Wolf"},
  ];

  public isManufacturerSelect: boolean[] = [];

  @ViewChildren(NgModel) inputs: QueryList<NgModel>;
  private inputSubscriptions: Subscription[] = [];
  private readonly modelSub: Subscription;
  private readonly generalGatewaySub: Subscription;

  constructor(
    private shareService: ShareService,
    public validationService: ValidationService
  ) {
    this.model = this.shareService.heatingInformation || new HeatingInformationModel();
    this.modelSub = this.shareService.heatingInformation$.subscribe((data) => {
      this.model = data || new HeatingInformationModel();
      this.initHeatings();
    });
    this.generalGatewayModel = this.shareService.generalGateway || new GeneralGatewayModel();
    this.generalGatewaySub = this.shareService.generalGateway$.subscribe((data) => {
      this.generalGatewayModel = data || new GeneralGatewayModel();
    });
  }

  ngAfterViewInit(): void {
    this.initHeatings(true);

    this.inputs.forEach(input => {
      this.inputSubscriptions.push(input.control.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(() => {
        this.shareService.heatingInformation = this.model;
      }));
    });

    // Subscribe to changes in the list of inputs
    // (it is called if some input is added or removed from the form/page,
    // for example, because of *ngIf condition changes)
    this.inputs.changes.subscribe(() => {
      // Unsubscribe from old subscriptions
      this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());

      // Subscribe to new inputs
      this.inputs.forEach(input => {
        this.inputSubscriptions.push(input.control.valueChanges.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.shareService.heatingInformation = this.model;
        }));
      });
    });
  }

  public onAddHeatingBtnClicked(): void {
    this.model.heatings.push(new HeatingModel());
    this.isManufacturerSelect.push(true);
    this.shareService.heatingInformation = this.model;
  }

  // moved to sensors foto tab

  isSettingsBoxVisible(index: number, itemsCount: number) {
    // console.log('visible', index, );

    return this.isSubDistribution() || (index === 0 && itemsCount > 1);
  }

  removeHeatingByIndex(i: number) {
    if (i > 0) {
      this.model.heatings.splice(i, 1);
      this.isManufacturerSelect.splice(i, 1);
    }
    if (this.model.heatings.length === 1) {
      this.model.heatingControlType = undefined;
      this.model.heatingControlImage = null;
    }
    this.shareService.heatingInformation = this.model;
  }

  changeManufacturerInputType(index: number) {
    this.isManufacturerSelect[index] = !this.isManufacturerSelect[index];
    if (this.isManufacturerSelect[index]) {
      this.model.heatings[index].manufacturer = undefined;
    }
  }


  ngOnDestroy(): void {
    this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());
    if (this.modelSub) {
      this.modelSub.unsubscribe();
    }
    if (this.generalGatewaySub) {
      this.generalGatewaySub.unsubscribe();
    }
  }

  isSubDistribution(): boolean {
    return this.model?.heatings && this.model.heatings.length === 1 && this.model.heatings[0]?.heatingType === this.HeatingTypeEnum.SUB_DISTRIBUTION;
  }

  checkHeatingsFormat(event: any) {
    console.log('checkHeatingsFormat', event);
    if (event === 'SUB_DISTRIBUTION') {
      if (this.model?.heatings && this.model.heatings.length > 1) {
        let counter = this.model.heatings.length - 1;
        while (counter > 0) {
          this.model.heatings.pop();
          counter--;
        }
        this.model.heatings[0].heatingType = this.HeatingTypeEnum.SUB_DISTRIBUTION;
      }
    }
  }

  private initHeatings(firstInit?: boolean) {
    if (this.model) {
      if (!this.model.heatings) {
        this.model.heatings = [new HeatingModel()];
      }
      if (firstInit) {
        this.isManufacturerSelect = [];
        this.model.heatings.forEach(item => this.isManufacturerSelect.push(true));
        if (this.isManufacturerSelect.length === 0) {
          this.isManufacturerSelect.push(true);
        }
      }
    }
  }

}
